import { Component, Input, OnInit, Self, ViewChild, ViewEncapsulation } from '@angular/core';
import { DefaultValuesService } from 'src/app/services/defaultvalues.service';
import { EquipmentManagenementService } from 'src/app/services/equipmentmanagement.service';
import { forkJoin, map, takeUntil } from 'rxjs';
import { SoftwareReleaseItem } from './types/software-release';
import { EmtAllowedSoftwareReleaseLevelDto, EmtAllowedSoftwareReleaseType } from 'src/app/interfaces/emt/emt-allowed-softwarer-release';
import { DestroyService } from 'src/app/services/destroyservice';
import { MandatoryVersionListComponent } from './components/mandatory-version-list/mandatory-version-list.component';
import { MandatoryVersionLevelsComponent } from './components/mandatory-version-levels/mandatory-version-levels.component';
import { MandatoryVersionPeripheralListComponent } from './components/mandatory-version-peripheral-list/mandatory-version-peripheral-list.component';

@Component({
    selector: 'mandatoryversionupdate',
    templateUrl: './mandatoryversionupdate.component.html',
    styleUrls: ['./mandatoryversionupdate.component.less', '../../../../style/new-generic-styles.component.less', '../fieldsettings.component.less'],
    providers: [DestroyService],
    standalone: false
})
export class MandatoryVersionUpdateComponent implements OnInit {
    @ViewChild(MandatoryVersionListComponent)
    public list!: MandatoryVersionListComponent;
    @ViewChild(MandatoryVersionPeripheralListComponent)
    public listPeripherals!: MandatoryVersionPeripheralListComponent;
    @ViewChild(MandatoryVersionLevelsComponent)
    public levels!: MandatoryVersionLevelsComponent;

    @Input()
    public familyCodes: Map<number, { familyCode: string; familyCodeName: string }> = new Map();

    public softwareReleases: SoftwareReleaseItem[] = [];

    constructor(
        private emtService: EquipmentManagenementService,
        public defaults: DefaultValuesService,
        @Self() private readonly destroy$: DestroyService
    ) { }

    public ngOnInit() {
        this.loadAll();
        this.defaults.stageMessageChanges$
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                this.loadAll();
            });
    }

    public loadAll() {
        this.loadSoftwareReleases();
    }

    public onNewLevelSelected(level: EmtAllowedSoftwareReleaseLevelDto) {
        this.list.changeSelectedLevel(level);
    }
    public onNewGroupSelected(group: EMTGlobalControllerGroup) {
        this.listPeripherals.loadPeripheralSoftwareVersions(group.globalControllerGroupId)
    }
    private loadSoftwareReleases() {
        const controllerSoftwares$ = this.emtService.getControllerSoftwareReleases().pipe(
            map(response => response?.releasesList ?? []),
            map(list => list.map(x => ({
                id: x.controllerSoftwareVersionID,
                type: EmtAllowedSoftwareReleaseType.Controller,
                version: x.softwareVersion,
                name: x.releaseName,
                releaseDate: x.releaseDate,
                familyCodeId: x.familyCodeId,
            }) as SoftwareReleaseItem)),
        );

        forkJoin([controllerSoftwares$])
            .pipe(takeUntil(this.destroy$))
            .subscribe(([controllerSoftwares]) => {
                this.softwareReleases = [...controllerSoftwares];
            });
    }
}
